import React from "react";
import { Helmet } from "react-helmet";

const PageMeta = ({ sitePageTitle, ogMetaTags, basicMetaTags, twitterMetaTags}) => (
  <Helmet>
    {sitePageTitle && <title>{sitePageTitle}</title>}
    {Object.keys(ogMetaTags).map(
      (item, i) => (
        <meta property={item} content={ogMetaTags[item]} />
      )
    )}
    {Object.keys(basicMetaTags).map(
      (item, i) => (
         <meta name={item} content={basicMetaTags[item]} />
      )
    )}
    {Object.keys(twitterMetaTags).map(
      (item, i) => (
        <meta name={item} content={twitterMetaTags[item]} />
      )
    )}
  </Helmet>
);

PageMeta.defaultProps = {
  title: "",
};

export default PageMeta;
